import moment from 'moment';
export default {
    methods: {
        //funciones para el filtro
        customFilter(items, filters, filter, headers) {
            // Init the filter class.
            const cf = new this.$MultiFilters(items, filters, filter, headers);
            cf.registerFilter("nombres", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.nombres + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("ap_paterno", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.ap_paterno + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("ap_materno", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.ap_materno + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });

            return cf.runFilters();
        },
        filterNombres(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                nombres: val
            });
        },
        filterPaterno(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                ap_paterno: val
            });
        },
        filterMaterno(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                ap_materno: val
            });
        },
        recargar() {
            this.form = {};
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                nombres: ""
            });

            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                ap_paterno: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                ap_materno: ""
            });
        },
    }
};


// WEBPACK FOOTER //
// ./src/components/admin/asignacion_horario/mixins/Filtros.js